import i18n from '@opsbase/lib-i18n';
import IssueRequiredField, { issueRequiredFieldLabel, } from '@opsbase/lib-issue/IssueRequiredField/IssueRequiredField';
import IssueStatus from '@opsbase/lib-issue/IssueStatus/IssueStatus';
import Palette from '@opsbase/lib-palette';
import { useCss } from '@opsbase/web-css';
import EditableList from '@opsbase/web-editablelist/EditableList/EditableList';
import Card from '@opsbase/web-layout/Card/Card';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import Text from '@opsbase/web-ui/Text/Text';
import debounce from 'lodash/debounce';
import React, { useCallback, useMemo, useState } from 'react';
const makeMyClasses = () => ({
    root: {
        border: `1px solid ${Palette.Platinum.main}`,
        backgroundColor: Palette.WhiteSmoke.main,
    },
});
export function IssueEditCausesPane(props) {
    const { issue, onChange } = props;
    const myCss = useCss(makeMyClasses);
    const handleChange = useCallback((field, v) => {
        onChange({ [field]: v });
    }, [onChange]);
    return (React.createElement(Vertical, { gutter: true, padding: true, classes: { root: myCss.root } },
        React.createElement(EditCard, { issue: issue, field: IssueRequiredField.CAUSES, placeholder: i18n.t('enter-root-cause'), onChange: handleChange }),
        React.createElement(EditCard, { issue: issue, field: IssueRequiredField.CORRECTIVE_ACTIONS, placeholder: i18n.t('enter-corrective-action'), onChange: handleChange }),
        React.createElement(EditCard, { issue: issue, field: IssueRequiredField.PREVENTATIVE_ACTIONS, placeholder: i18n.t('enter-preventative-action'), onChange: handleChange })));
}
export default IssueEditCausesPane;
function EditCard({ issue, field, placeholder, onChange }) {
    const [items, setItems] = useState(issue[field].map((title, id) => ({ id, title })));
    const isClosed = (issue === null || issue === void 0 ? void 0 : issue.status) === IssueStatus.CLOSED;
    const _triggerChange = useMemo(() => debounce(v => {
        onChange(field, v.map(vv => vv.title).filter(vv => !!vv));
    }, 600, { trailing: true, leading: false }), [field, onChange]);
    const handleChange = useCallback(v => {
        setItems(v);
        _triggerChange(v);
    }, [_triggerChange]);
    return (React.createElement(Card, { padding: true },
        React.createElement(Text, null, issueRequiredFieldLabel(field)),
        React.createElement(EditableList, { disabled: isClosed, autoSelectIdx: 0, placeholder: placeholder, canAddAtBottom: !isClosed, canDelete: !isClosed, multiline: true, maxWidth: 500, items: items, onChange: handleChange })));
}
